(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1533],{

/***/ 4875:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter",
      function () {
        return __webpack_require__(75051);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ newsletter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
;// CONCATENATED MODULE: ./src/assets/headers/lexus-newsletter.png
/* harmony default export */ var lexus_newsletter = ({"src":"https://forms-assets.toyota.co.uk/_next/static/media/lexus-newsletter.e1a05be5.png","height":1079,"width":1973,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAAb0lEQVR42gFkAJv/AJCyxZm3xq3G1JOns1xdaWtveVZaZiQuPwC1yNHAzNG8xsuNlpw8QEc1ODwqMj8sOEkAusPFz8/OtLS0paOlmJWXbWxvPj1GKCUxAIeMlKGgpIyLj2RRUm9VVHBUUnRZVXBWU+nNL3330Ux1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/headers/toyota-newsletter.png
/* harmony default export */ var toyota_newsletter = ({"src":"https://forms-assets.toyota.co.uk/_next/static/media/toyota-newsletter.2ce27856.png","height":1053,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAAb0lEQVR42gFkAJv/ALKJaLyZf8+wmNe7pNzCquDIs+nTwK+imgCqoZ7Ct7G1qKKYioNnZWiDe3fdzcHBt7AArKOhw7awlImFmY2EsaKXw7So5tfL5tjNAJeTlLGnpMK2sMS5s8rAucC5tqmmpoaIjofTQFjeYySlAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./src/components/form/fields/index.ts + 88 modules
var fields = __webpack_require__(68143);
// EXTERNAL MODULE: ./src/components/form/layout/index.ts + 2 modules
var layout = __webpack_require__(76817);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 8 modules
var ui = __webpack_require__(98655);
// EXTERNAL MODULE: ./src/contexts/index.tsx + 96 modules
var contexts = __webpack_require__(28798);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(97859);
// EXTERNAL MODULE: ./src/utils/constants/index.ts
var constants = __webpack_require__(47392);
// EXTERNAL MODULE: ./src/utils/helpers/index.ts + 9 modules
var helpers = __webpack_require__(45911);
// EXTERNAL MODULE: ./src/utils/helpers/tracking.ts + 1 modules
var helpers_tracking = __webpack_require__(68379);
// EXTERNAL MODULE: ./src/utils/schemas/index.ts + 45 modules
var schemas = __webpack_require__(73705);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(46392);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
;// CONCATENATED MODULE: ./src/pages/newsletter/index.tsx
/* eslint-disable @next/next/no-img-element */ /* eslint-disable no-nested-ternary */ 














const Newsletter = (param)=>{
    let { models , content , tracking , brand  } = param;
    const campaign = (0,contexts/* useCampaign */.yQ)();
    const [submitResponse, setSubmitResponse] = (0,react.useState)("");
    const initialValues = {
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        model: "",
        toyota_owner: false,
        reg_num: "",
        consent: {
            user: false
        },
        response_code: "",
        campaign_response_code: "",
        campaign_code: "",
        is_lexus: brand === "lexus"
    };
    const methods = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schemas/* NewsletterSchema */.cZ),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    const regRequired = JSON.parse(methods.watch("toyota_owner"));
    const postMessage = (event)=>{
        let data;
        if (typeof event.data === "object") {
            data = event.data;
        } else {
            data = JSON.parse(event.data);
        }
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty("sendNewsletterEmailAddress")) {
            if (data.sendNewsletterEmailAddress) {
                methods.setValue("email", data.sendNewsletterEmailAddress);
            }
        }
    };
    (0,react.useEffect)(()=>{
        const isOwner = JSON.parse(methods.getValues("toyota_owner"));
        if (!isOwner) {
            methods.resetField("reg_num");
        }
    }, [
        regRequired
    ]);
    (0,react.useEffect)(()=>{
        if (window.self !== window.top) {
            // eslint-disable-next-line no-restricted-globals
            parent.postMessage("requestNewsletterEmailAddress", "*");
        }
        window.addEventListener("message", postMessage, false);
        return ()=>{
            window.removeEventListener("message", postMessage, false);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (campaign === null || campaign === void 0 ? void 0 : campaign.campaign) {
            methods.setValue("campaign_code", campaign.campaign);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.media) {
            const code = methods.getValues("campaign_code");
            methods.setValue("campaign_code", code + campaign.media);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.brochure) {
            methods.setValue("campaign_response_code", campaign.brochure);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign
    ]);
    const onSubmit = async (data)=>{
        var ref, ref1;
        const formData = data;
        const selectedModel = models.filter((model)=>model.d4t4.id === formData.model)[0];
        formData.response_code = brand === "lexus" ? "RC60284" : "RC81050";
        if (brand === "toyota" && (selectedModel === null || selectedModel === void 0 ? void 0 : (ref = selectedModel.responsecodes) === null || ref === void 0 ? void 0 : ref.national_newsletter)) formData.response_code = selectedModel === null || selectedModel === void 0 ? void 0 : (ref1 = selectedModel.responsecodes) === null || ref1 === void 0 ? void 0 : ref1.national_newsletter;
        setSubmitResponse("");
        await (0,axios/* default */.ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/newsletter"),
            headers: {
                "Content-Type": "application/json"
            },
            data: formData
        }).then(()=>{
            (0,helpers_tracking/* formEvent */.Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: "",
                page: tracking.page
            });
            (0,helpers/* closeOverlay */.Km)(content.confirmation.title, content.confirmation.copy, setSubmitResponse, brand === "lexus");
        }).catch(()=>{
            (0,helpers_tracking/* formEvent */.Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: "",
                page: tracking.page
            });
            setSubmitResponse(constants/* ERROR_MESSAGE */.c9);
            throw new Error(constants/* ERROR_MESSAGE */.c9);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            brand === "lexus" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Nav */.JL, {
                title: content.title,
                background: lexus_newsletter
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Nav */.JL, {
                title: content.title,
                background: toyota_newsletter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormWrapper */.n, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormStep */.p, {
                    title: content.details.title,
                    subtitle: content.details.subtitle,
                    active: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* AuthFill */.Pl, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Title */.Dx, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* FirstName */.SW, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* LastName */.uQ, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Email */.GT, {}),
                                brand !== "lexus" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Models */.kk, {
                                            models: models,
                                            label: "Model of interest",
                                            optional: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* IsCurrentOwner */.fC, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* MarketingConsent */.nb, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Button */.zx, {
                                    submitResponse: submitResponse,
                                    children: content.details.submit
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
Newsletter.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ var newsletter = (Newsletter);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,8655,4817,9774,2888,179], function() { return __webpack_exec__(4875); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);